// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--2ERxY","name":"index-module--name--1kKx8","position":"index-module--position--22O3p"};